import { api } from "./client";

export interface AuthMe {
  user: {
    id: number;
    name: string;
    email: string;
    rol: string;
    foto_url?: string | null;
    foto_path?: string | null;
    foto_updated_at?: string | null;
    departamento?: string | null;
    empresa?: string | null;
    fecha_nacimiento?: string | null;
    fecha_inicio_contratacion?: string | null;
    creado_en?: string | null;
    last_activity?: string | null;
  };
  roles: string[];
  permissions: string[];
  branding?: {
    nombre: string;
    eslogan: string;
    logo_url: string | null;
  };
  emisores: Array<{ id: number; nombre: string; cif: string | null }>;
  emisor_id: number | null;
}

export type UpdateProfilePayload = {
  nombre: string;
  contrasena?: string;
  foto?: File | null;
  fecha_nacimiento?: string | null;
};

export const authApi = {
  async me(): Promise<AuthMe> {
    const { data } = await api.get<AuthMe>("/auth/me");
    return data;
  },

  async login(
    email: string,
    password: string,
    remember = false,
  ): Promise<AuthMe> {
    const { data } = await api.post<AuthMe>("/auth/login", {
      email,
      password,
      remember,
    });
    return data;
  },

  async logout(): Promise<void> {
    await api.post("/auth/logout", undefined, { timeout: 1500 });
  },

  async selectEmisor(emisorId: number): Promise<AuthMe> {
    const { data } = await api.post<AuthMe>("/auth/select-emisor", {
      emisor_id: emisorId,
    });
    return data;
  },

  async updateProfile(payload: UpdateProfilePayload): Promise<AuthMe> {
    const formData = new FormData();

    formData.append("nombre", payload.nombre);
    formData.append("fecha_nacimiento", payload.fecha_nacimiento ?? "");

    if (payload.contrasena) {
      formData.append("contrasena", payload.contrasena);
    }

    if (payload.foto) {
      formData.append("foto", payload.foto);
    }

    const { data } = await api.post<AuthMe>("/auth/profile", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return data;
  },
};
